module.exports = require('./_global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// D:/Work/Development/vsts_build/_work/2/s/web/node_modules/core-js/modules/_html.js
// module id = Ed9o
// module chunks = 2